import React from 'react';
import LegalLayout from './LegalLayout';

const Article = ({ num, title, children }) => (
  <section className="border-l-4 border-[#205F79]/20 pl-5 py-1">
    <h2 className="text-xl font-bold text-gray-900 mb-3">
      <span className="text-[#205F79]">Article {num}</span> — {title}
    </h2>
    <div className="space-y-3 text-[15px] leading-relaxed">{children}</div>
  </section>
);

const Field = ({ label, value }) => (
  <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-3 py-1.5">
    <span className="text-sm font-semibold text-gray-600 sm:w-44 shrink-0">{label} :</span>
    <span className="text-sm text-gray-900">
      {value || <span className="inline-block min-w-[200px] border-b border-dashed border-gray-400 text-gray-400 italic">[à compléter]</span>}
    </span>
  </div>
);

const MentionsLegales = () => (
  <LegalLayout title="Mentions Légales" lastUpdated="Mai 2026">
    <p className="text-gray-600">
      Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique
      (LCEN), il est porté à la connaissance des utilisateurs du site et de l'application <strong>DIP PILOTE +IA</strong>
      (ci-après « le Service ») les présentes mentions légales.
    </p>

    <Article num={1} title="Éditeur du Service">
      <div className="bg-gray-50 rounded-lg p-5 border border-gray-200">
        <Field label="Nom / Raison sociale" value="Lilian Vergès" />
        <Field label="Statut juridique" value="Auto-entrepreneur (en cours d'immatriculation)" />
        <Field label="Adresse" value="76 route du Sentin" />
        <Field label="Code postal / Ville" value="40390 Saint-Martin-de-Hinx" />
        <Field label="Pays" value="France" />
        <Field label="Email de contact" value="dippilote@outlook.com" />
        <Field label="Téléphone" />
        <Field label="SIRET" value="En cours d'immatriculation" />
        <Field label="N° TVA intracommunautaire" value="Non applicable (régime de la franchise en base — auto-entrepreneur)" />
        <Field label="Directeur de la publication" value="Lilian Vergès" />
      </div>
    </Article>

    <Article num={2} title="Hébergement du Service">
      <div className="bg-gray-50 rounded-lg p-5 border border-gray-200">
        <Field label="Hébergeur" value="Emergent (plateforme SaaS)" />
        <Field label="Site web" value="https://emergent.sh" />
        <Field label="Localisation" value="Hébergement cloud — Union européenne" />
      </div>
    </Article>

    <Article num={3} title="Propriété intellectuelle">
      <p>
        L'ensemble des éléments composant le Service (code source, design, logo, textes, illustrations, base de données INCI,
        modèles de DIP) est la propriété exclusive de l'éditeur, à l'exception des contenus expressément placés sous une
        autre licence.
      </p>
      <p>
        Toute reproduction, représentation, modification, publication, transmission, dénaturation, totale ou partielle du
        Service ou de son contenu, par quelque procédé que ce soit, et sur quelque support que ce soit, est interdite sans
        autorisation écrite préalable de l'éditeur. Toute exploitation non autorisée est susceptible de constituer un acte
        de contrefaçon engageant la responsabilité civile et pénale de son auteur (articles L.335-2 et suivants du Code de
        la propriété intellectuelle).
      </p>
      <p>
        En revanche, les <strong>données saisies par l'utilisateur</strong> (formules, recettes, produits, photos d'étiquettes,
        rapports toxicologiques, etc.) demeurent la <strong>propriété pleine et entière de l'utilisateur</strong>.
      </p>
    </Article>

    <Article num={4} title="Liens hypertextes">
      <p>
        Le Service peut contenir des liens hypertextes vers d'autres sites Internet. L'éditeur n'exerce aucun contrôle sur
        ces sites et décline toute responsabilité quant à leur contenu et leurs pratiques.
      </p>
    </Article>

    <Article num={5} title="Crédits">
      <p>
        Logo, design, développement : DIP PILOTE +IA. Composants UI : shadcn/ui (MIT). Icônes : Lucide (ISC).
        Génération de PDF : WeasyPrint, PyMuPDF. Paiements : Stripe. Assistant IA : technologie OpenAI accessible via
        Emergent Universal Key.
      </p>
    </Article>

    <Article num={6} title="Contact">
      <p>
        Pour toute question relative aux présentes mentions légales ou au Service, vous pouvez nous contacter à l'adresse
        suivante : <strong>dippilote@outlook.com</strong>, ou via le module « Support » disponible directement dans
        l'application après connexion.
      </p>
    </Article>
  </LegalLayout>
);

export default MentionsLegales;
